import { createSlice } from "@reduxjs/toolkit";
import { userAction } from "../action/userAction";

export const initialState = {
  userList: [],
};

const userSlice = createSlice({
  name: "users",
  initialState: initialState,
  reducers: userAction,
});

export const { setUserList } = userSlice.actions;

export default userSlice.reducer;
